export default __webpack_public_path__ + "f189a81abf0e6652b9c0bbc3d2de5425.png";